export { default, defaultQuestionGroup } from './atom'
